import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface User {
  name?: string | null | undefined;
  company?: string | null | undefined;
  email: string | null | undefined;
  typeTenant?: string | null | undefined;
  password?: string | null | undefined;
}

export type TenantContext = 'Tomador' | 'Prestador' | 'Moderação';

export interface Tenant {
  email: string | null | undefined;
  name?: string | null | undefined;
  uuid?: string | null | undefined;
  status?: string | null | undefined;
  type?: TenantContext | null | undefined;
}

export interface UserToken {
  access_token: string;
  tenants: Tenant[];
  user: User;
}

export interface SelectedTenantResponse {
  access_token: string;
  tenant: Tenant;
  user: User;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly apiUrl = environment.AUTH_API_URL;

  constructor(private http: HttpClient) {}

  signUp(data: User): Observable<HttpResponse<Tenant>> {
    return this.http.post<Tenant>(`${this.apiUrl}/tenant`, data, {
      observe: 'response',
    });
  }

  signIn(data: User): Observable<HttpResponse<UserToken>> {
    return this.http.post<UserToken>(`${this.apiUrl}/login`, data, {
      observe: 'response',
    });
  }

  forgotPassword(data: any): Observable<HttpResponse<String>> {
    return this.http.get<String>(
      `${this.apiUrl}/forgot-password/${data.email}`,
      {
        observe: 'response',
      },
    );
  }

  resetPassword(
    data: any,
    access_token: string,
  ): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.apiUrl}/change-password`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      observe: 'response',
    });
  }

  acceptModeratorInvitation(data: {
    token: string;
    password: string;
    passwordConfirmation: string;
  }): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/moderation/moderator-invitations/accept`,
      data,
    );
  }

  chooseTenant(
    tenantUuid: string | null | undefined,
    access_token: string | null,
  ): Observable<SelectedTenantResponse> {
    return this.http.post<SelectedTenantResponse>(
      `${this.apiUrl}/chose-tenant/${tenantUuid}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }
}
